export default {
  loading: false,
};
